import Checkbox from "../atoms/checkboxnew"
import { HorizontalLayout, VerticalLayout } from "../components/layout"

export const CheckOrder = ({description, checked, handleCheck}) => {
    return(
        <HorizontalLayout style={{marginTop:"1rem"}}>
            <Checkbox onChange={handleCheck} checked={checked}/>
            <p className="normal-text-dark light-bold text-margin-left">
                    {description}
            </p>
        </HorizontalLayout>
    )
}


export const OrderDetails = ({details}) => {
    return(
        <VerticalLayout className="card-background-color" style={{padding:"1.5rem", width: 'calc(100% - 3rem)'}}>
                <h5 className="standard-text-color">Pakket:</h5>
                <p className="standard-text-color"><b>Naam: </b>{details.title}</p>
                <p className="standard-text-color"><b>Kosten: </b>{details.value}</p>
        </VerticalLayout>
    )
}